(() => {
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => Array.from(el.querySelectorAll(s));

  /* ---------- Drawers ---------- */
  let lastFocus = null;
  function openDrawer(id) {
    const d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    const f = d.querySelector('[data-close]');
    if (f) setTimeout(() => f.focus(), 50);
  }
  function closeDrawer(d) {
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) {
      const id = opener.getAttribute('data-open');
      if (id === 'SearchOverlay') { openSearch(); e.preventDefault(); return; }
      e.preventDefault();
      openDrawer(id);
      return;
    }
    const closer = e.target.closest('[data-close]');
    if (closer) {
      const d = closer.closest('.drawer');
      if (d) closeDrawer(d);
      const s = closer.closest('.search-ov');
      if (s) s.classList.remove('is-open');
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('.drawer.is-open').forEach(closeDrawer);
    const s = $('.search-ov.is-open');
    if (s) s.classList.remove('is-open');
  });
  function openSearch() {
    const s = $('#SearchOverlay');
    if (!s) return;
    s.classList.add('is-open');
    setTimeout(() => { const i = s.querySelector('input'); if (i) i.focus(); }, 80);
  }

  /* ---------- Cart ---------- */
  const SECTION = 'cart-drawer';
  function renderCart(sections) {
    if (!sections || !sections[SECTION]) return;
    const doc = new DOMParser().parseFromString(sections[SECTION], 'text/html');
    const fresh = doc.querySelector('#CartDrawerInner');
    const cur = $('#CartDrawerInner');
    if (fresh && cur) cur.innerHTML = fresh.innerHTML;
    const count = doc.querySelector('[data-cart-count-src]');
    if (count) $$('[data-cart-count]').forEach((el) => (el.textContent = count.textContent));
  }
  async function addToCart(id, qty = 1) {
    const res = await fetch(window.theme.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }], sections: SECTION })
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
    renderCart(data.sections);
    openDrawer('CartDrawer');
    return data;
  }
  async function changeLine(line, quantity) {
    const inner = $('#CartDrawerInner');
    if (inner) inner.classList.add('is-busy');
    try {
      const res = await fetch(window.theme.routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: SECTION })
      });
      const data = await res.json();
      renderCart(data.sections);
    } finally {
      const i = $('#CartDrawerInner');
      if (i) i.classList.remove('is-busy');
    }
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-line-change]');
    if (!b) return;
    e.preventDefault();
    changeLine(Number(b.dataset.line), Number(b.dataset.qty));
  });

  /* Quick add on product cards */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-quick-add]');
    if (!b || b.disabled) return;
    e.preventDefault();
    b.classList.add('is-loading');
    try {
      await addToCart(b.dataset.quickAdd);
      b.classList.add('is-added');
      setTimeout(() => b.classList.remove('is-added'), 1200);
    } catch (err) {
      alert(err.message);
    } finally {
      b.classList.remove('is-loading');
    }
  });

  /* ---------- Product form ---------- */
  function formatMoney(cents) {
    const fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    const val = (cents / 100);
    const map = {
      amount: val.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','),
      amount_no_decimals: Math.round(val).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
      amount_with_comma_separator: val.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'),
      amount_no_decimals_with_comma_separator: Math.round(val).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => map[k] || map.amount);
  }

  $$('[data-product-form]').forEach((root) => {
    const dataEl = root.querySelector('[data-variants]');
    if (!dataEl) return;
    const variants = JSON.parse(dataEl.textContent);
    const preorderTag = root.dataset.preorder === 'true';
    const idInput = root.querySelector('input[name="id"]');
    const btn = root.querySelector('[data-add-btn]');
    const btnLabel = root.querySelector('[data-add-label]');
    const priceEl = root.querySelector('[data-price]');
    const notify = root.querySelector('[data-notify]');
    const optionCount = root.querySelectorAll('[data-option-index]').length;

    function selected() {
      const vals = [];
      for (let i = 0; i < optionCount; i++) {
        const c = root.querySelector(`[data-option-index="${i}"] input:checked`);
        vals.push(c ? c.value : null);
      }
      return vals;
    }
    function update() {
      const vals = selected();
      const v = variants.find((x) => x.options.every((o, i) => o === vals[i]));
      // availability per option value given other selections
      $$('[data-option-index]', root).forEach((group) => {
        const idx = Number(group.dataset.optionIndex);
        const label = group.querySelector('[data-selected-value]');
        if (label) label.textContent = vals[idx] || '';
        $$('input', group).forEach((inp) => {
          const test = vals.slice();
          test[idx] = inp.value;
          const mv = variants.find((x) => x.options.every((o, i) => o === test[i]));
          const lbl = inp.nextElementSibling;
          if (lbl) lbl.classList.toggle('is-unavailable', !mv || !mv.available);
        });
      });
      if (!v) {
        btn.disabled = true;
        btnLabel.textContent = 'UNAVAILABLE';
        return;
      }
      idInput.value = v.id;
      const pre = v.available && (preorderTag || v.preorder);
      btn.disabled = !v.available;
      btnLabel.textContent = !v.available ? 'SOLD OUT' : pre ? 'PRE-ORDER' : 'ADD TO CART';
      if (notify) notify.hidden = v.available;
      if (priceEl) {
        priceEl.innerHTML = (v.compare_at_price > v.price ? `<s>${formatMoney(v.compare_at_price)}</s>` : '') + formatMoney(v.price);
      }
      if (v.featured_media) {
        const target = document.querySelector(`[data-media-id="${v.featured_media}"]`);
        if (target && window.matchMedia('(max-width: 989px)').matches) {
          target.parentElement.scrollTo({ left: target.offsetLeft - target.parentElement.offsetLeft, behavior: 'smooth' });
        }
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    root.addEventListener('change', (e) => { if (e.target.closest('[data-option-index]')) update(); });
    update();

    const form = root.querySelector('form[data-add-form]');
    if (form) form.addEventListener('submit', async (e) => {
      e.preventDefault();
      btn.disabled = true;
      const old = btnLabel.textContent;
      btnLabel.textContent = 'ADDING…';
      try { await addToCart(idInput.value, 1); btnLabel.textContent = 'ADDED'; }
      catch (err) { alert(err.message); }
      setTimeout(() => { btnLabel.textContent = old; update(); }, 900);
    });
  });

  /* Mobile gallery counter */
  $$('[data-gallery]').forEach((g) => {
    const counter = g.parentElement.querySelector('[data-gallery-count]');
    if (!counter) return;
    const items = g.children.length;
    g.addEventListener('scroll', () => {
      const i = Math.round(g.scrollLeft / (g.children[0].offsetWidth + 4)) + 1;
      counter.textContent = `${Math.min(i, items)} / ${items}`;
    }, { passive: true });
  });

  /* Collection sort */
  $$('[data-sort]').forEach((s) => s.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', s.value);
    window.location = url.toString();
  }));

  /* Localization selector */
  $$('[data-localization] select').forEach((s) => s.addEventListener('change', () => s.form.submit()));
})();
